import api from "../api";
import { useMutation } from "@tanstack/vue-query";

const switchOrganization = async (org: number) => {
  const response = await api.post(`/users/switch_current_organization`, { organization_id: org });

  return response.data;
};

const useSwitchOrganizationMutation = () => {
  return useMutation({
    mutationFn: (org: number) => switchOrganization(org)
  });
};

export default useSwitchOrganizationMutation;
